import { useCallback } from "react";
import {
  useSessionTenantApiOrigin,
  useSessionTenantOrigin,
  useSessionTenantEdgeOrigin,
} from "../../hooks/useSessionTenantOrigin";
import { connectorOauthRedirectBase } from "../../lib/tenantOrigin";

export function useRenderWithPlaceholders() {
  const edgeOrigin = useSessionTenantEdgeOrigin();
  const appOrigin = useSessionTenantOrigin();
  const apiOrigin = useSessionTenantApiOrigin();
  const oauthRedirectBase = connectorOauthRedirectBase(apiOrigin);
  return useCallback(
    (text: string, values?: Record<string, string>) => {
      const staticValues: Record<string, string> = {
        UI_URL: edgeOrigin,
        API_URL: appOrigin,
        OIDC_PROVIDER_URL: apiOrigin,
      };
      const rendered = text.replace(/\{([^}]+)\}/g, (match, key) => {
        return values?.[key] ?? staticValues[key] ?? match;
      });
      // Manifests retain the legacy placeholder spelling, so copy fields must
      // rebase it onto the redirect URI the backend still mints.
      return rendered.replaceAll(
        `${appOrigin}/connected-apps/oauth/`,
        oauthRedirectBase
      );
    },
    [edgeOrigin, appOrigin, apiOrigin, oauthRedirectBase]
  );
}
